/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchLiffMemoryMemoryIdRequest
 */
export interface PatchLiffMemoryMemoryIdRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchLiffMemoryMemoryIdRequest
     */
    respondContent?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchLiffMemoryMemoryIdRequest
     */
    filePaths?: Array<string>;
}

/**
 * Check if a given object implements the PatchLiffMemoryMemoryIdRequest interface.
 */
export function instanceOfPatchLiffMemoryMemoryIdRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatchLiffMemoryMemoryIdRequestFromJSON(json: any): PatchLiffMemoryMemoryIdRequest {
    return PatchLiffMemoryMemoryIdRequestFromJSONTyped(json, false);
}

export function PatchLiffMemoryMemoryIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchLiffMemoryMemoryIdRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'respondContent': !exists(json, 'respondContent') ? undefined : json['respondContent'],
        'filePaths': !exists(json, 'filePaths') ? undefined : json['filePaths'],
    };
}

export function PatchLiffMemoryMemoryIdRequestToJSON(value?: PatchLiffMemoryMemoryIdRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'respondContent': value.respondContent,
        'filePaths': value.filePaths,
    };
}

